import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { clearCreatedUser, createUser } from '../userManagementActions';
import PropTypes from 'prop-types';
import { getCreateUserErrorMessage, getIsCreateUserSuccessful, getIsCreateUserLoading, getCreatedUser } from '../userManagementEntity';
import { toastIfError } from '../../../utils/toast';
import { toggleModal } from '../../Modal/modalActions';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';
import UserForm from '../UserForm/UserForm';

export class CreateUser extends Component {
    static propTypes = {
        onCreateUser: PropTypes.func.isRequired,
        createUserError: PropTypes.string,
        isCreateUserLoading: PropTypes.bool,
        isCreateUserSuccessful: PropTypes.bool,
        onToggleModal: PropTypes.func.isRequired,
        createdUser: PropTypes.any,
        clearCreatedUser: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            role: undefined,
            merchantIds: [],
            payoutAccountIds: []
        };
    }

    componentDidUpdate(previousProps) {
        toastIfError(previousProps, this.props, 'createUserError');

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isCreateUserSuccessful') && this.props.isCreateUserSuccessful) {
            this.props.onToggleModal('createUser');

            toast('New User Has Successfully Been Invited.', { type: 'success' });
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'createdUser') && this.props.createdUser) {
            this.props.onToggleModal('editUser', this.props.createdUser);
            this.props.clearCreatedUser();
        }
    }

    handleUsernameChange = (e) => {
        this.setState({
            username: e.target.value
        });
    };

    handleMerchantsChange = (selectedOptions = []) => {
        const merchantIds = selectedOptions.map((option) => option.value);

        this.setState({
            merchantIds
        });
    };

    handlePayoutAccountsChange = (selectedOptions = []) => {
        const payoutAccountIds = selectedOptions.map((option) => option.value);

        this.setState({ payoutAccountIds });
    };

    handleSelectAccessRole = (role) => {
        this.setState({ role });
    };

    handleCreateUser = () => {
        let role = this.state.role;
        let isApiUser = false;
        if (this.state.role === 'API') {
            role = 'W';
            isApiUser = true;
        }

        this.props.onCreateUser(this.state.merchantIds, this.state.payoutAccountIds, this.state.username, role, isApiUser);
    };

    handleOpenModal = () => {
        this.setState({
            username: '',
            merchantIds: [],
            payoutAccountIds: [],
            role: undefined
        });
    };

    render() {
        return (<UserForm
            username={this.state.username}
            isSubmitLoading={this.props.isCreateUserLoading}
            isApiUser={this.state.role === 'API'}
            merchantIds={this.state.merchantIds}
            payoutAccountIds={this.state.payoutAccountIds}
            modalTitle="Create New User"
            onUsernameChange={this.handleUsernameChange}
            onMerchantsChange={this.handleMerchantsChange}
            onPayoutAccountsChange={this.handlePayoutAccountsChange}
            onOpen={this.handleOpenModal}
            onSelectAccessRole={this.handleSelectAccessRole}
            onSubmit={this.handleCreateUser}
            role={this.state.role}
            submitText="Send Invite"
            uniqueModalName="createUser"
        />);
    }
}

export function mapStateToProps(state) {
    return {
        createUserError: getCreateUserErrorMessage(state),
        isCreateUserLoading: getIsCreateUserLoading(state),
        isCreateUserSuccessful: getIsCreateUserSuccessful(state),
        createdUser: getCreatedUser(state)
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        onCreateUser: (merchantIds, payoutAccountIds, username, role, isApiUser) => {
            dispatch(createUser(merchantIds, payoutAccountIds, username, role, isApiUser));
        },
        onToggleModal: (modalName, user) => dispatch(toggleModal(modalName, user)),
        clearCreatedUser: () => dispatch(clearCreatedUser())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUser);
